/* Duskhaven symbol draw (2026-10-07, settle fix 2026-10-08). A product's symbol draws itself once, using a self-animating
   SVG (assets/dh-draw-<name>.svg) shown through an <img>. An <img> only restarts an SVG animation when it (re)loads, so the
   markup (snippets/dh-symbol.liquid, assets/dh-symbols.js) starts with a 1x1 transparent src plus
   data-dh-draw (animated file) and data-dh-static (the finished mark), and this script sets src when it is time:
   - cards, product page, cart page: when the symbol is at least half visible; inside a card that is still fading up
     (assets/dh-motion.js) it starts the moment the card's rise has finished, never later than 1.2s
   - cart drawer: every time the drawer opens (a re-render while it stays open does not replay)
   - prefers-reduced-motion: the finished mark is shown straight away, nothing animates
   ONE AT A TIME (Todd, 2026-10-08): symbols never draw together. Each one that is ready joins a queue (enqueue below) that plays
   them in reading order (top row first, left to right) with one symbol drawing at a time, so each can be watched on its own.
   Without JavaScript the <noscript> twin of the image (a plain masked symbol) is shown instead.
   window.dhDrawReplay(el) replays on demand (el = the img, or a container holding it).
   Which products draw is decided by ONE list per language: dh_draw_list in snippets/dh-symbol.liquid and DRAW in
   assets/dh-symbols.js. Plain script (no import()), loaded with defer from snippets/dh-head.liquid. */
(function () {
  'use strict';
  if (window.__dhDraw) return;
  window.__dhDraw = true;

  var d = document;
  var SEL = 'img[data-dh-draw]';
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var drawerOpenAt = 0;

  function bust(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'r=' + Date.now(); }

  function setStatic(img) {
    var s = img.getAttribute('data-dh-static');
    if (!s) return;
    img.setAttribute('data-dh-state', 'static');
    img.src = s;
  }

  function play(img, again) {
    var u = img.getAttribute('data-dh-draw');
    if (!u) return;
    if (reduce) { setStatic(img); return; }
    img.setAttribute('data-dh-state', 'anim');
    img.src = again ? bust(u) : u;
  }

  window.dhDrawReplay = function (el) {
    if (!el) return;
    var list = (el.matches && el.matches(SEL)) ? [el] : [].slice.call(el.querySelectorAll ? el.querySelectorAll(SEL) : []);
    list.forEach(function (img) { img.__dhd = 1; play(img, true); });
  };


  /* ---- One at a time. Every symbol that is ready to draw joins this queue. A short wait (60ms) lets symbols that become
     ready together be sorted into reading order: rows from the top (60px bands), then left to right. One symbol plays per
     SLOT; the next starts GAP after. A symbol that has scrolled out of view by its turn goes back to the observer and
     draws when it is next seen, so nothing is skipped and nothing plays unseen. */
  var SLOT = 2000, GAP = 150;
  var queue = [], busy = false, pumpT = 0;
  function order(a, b) {
    var ra = a.img.getBoundingClientRect(), rb = b.img.getBoundingClientRect();
    var rowA = Math.round(ra.top / 60), rowB = Math.round(rb.top / 60);
    return (rowA - rowB) || (ra.left - rb.left);
  }
  function inView(img) {
    var r = img.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || 0) && r.right > 0 && r.left < (window.innerWidth || 0);
  }
  function run() {
    pumpT = 0;
    if (busy || !queue.length) return;
    queue.sort(order);
    var it = queue.shift(), img = it.img;
    img.__dhq = 0;
    if (!img.isConnected) { run(); return; }
    if (!inView(img)) {
      if (img.closest('theme-drawer') || !io) setStatic(img); else io.observe(img);
      run(); return;
    }
    busy = true;
    play(img, it.again);
    setTimeout(function () { busy = false; pump(); }, SLOT + GAP);
  }
  function pump() { if (!busy && queue.length && !pumpT) pumpT = setTimeout(run, 60); }
  function enqueue(img, again) {
    if (img.__dhq) return;
    img.__dhq = 1;
    queue.push({ img: img, again: !!again });
    pump();
  }

  /* Inside a card that assets/dh-motion.js reveals, become ready the moment the card has settled:
     - card already shown (or motion not acting on it): straight away
     - card mid-rise: when its dh-rise animation finishes (other, unrelated animations are ignored)
     - card still hidden: as soon as it is revealed, then as above
     Caps keep it moving (shortened 2026-10-08): a visible card never waits more than 0.15s for a reveal that is not coming,
     nothing waits longer than 1.2s in total (dh-motion itself reveals anything left hidden after 2s). */
  function settle(img, cb) {
    var card = img.closest('[data-dh-rv]');
    if (!card) { cb(); return; }
    var fired = false;
    var mo = null;
    function go() { if (fired) return; fired = true; if (mo) { try { mo.disconnect(); } catch (e) {} } cb(); }
    function visible() {
      try { return parseFloat(getComputedStyle(card).opacity) > 0.98; } catch (e) { return true; }
    }
    function afterIn() {
      var rise = null;
      try {
        rise = card.getAnimations().filter(function (a) { return a.animationName === 'dh-rise'; })[0];
      } catch (e) {}
      if (!rise) { go(); return; }
      rise.finished.then(go, go);
      setTimeout(go, 900);
    }
    if (card.classList.contains('dh-in') || visible()) { afterIn(); return; }
    try {
      mo = new MutationObserver(function () {
        if (card.classList.contains('dh-in')) { try { mo.disconnect(); } catch (e) {} afterIn(); }
      });
      mo.observe(card, { attributes: true, attributeFilter: ['class'] });
    } catch (e) { go(); return; }
    setTimeout(function () { if (!fired && visible()) go(); }, 150);
    setTimeout(go, 1200);
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var img = e.target;
        io.unobserve(img);
        settle(img, function () { enqueue(img, false); });
      });
    }, { threshold: 0.5 });
  }

  function init(img) {
    if (img.__dhd) return;
    img.__dhd = 1;
    if (reduce || !io) { setStatic(img); return; }
    var drawer = img.closest('theme-drawer');
    if (drawer) {
      /* Cart drawer: the open handler below plays these. Lines that arrive while it has just opened (the add-to-cart
         render) play too; later re-renders keep the finished mark. */
      if (drawer.hasAttribute('open')) {
        if (Date.now() - drawerOpenAt < 2500) enqueue(img, true); else setStatic(img);
      }
      return;
    }
    io.observe(img);
  }

  function scan() {
    [].slice.call(d.querySelectorAll(SEL)).forEach(init);
  }

  /* Cart drawer opened: draw every symbol in it again. */
  try {
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        var t = m.target;
        if (!t || t.tagName !== 'THEME-DRAWER' || !t.hasAttribute('open')) return;
        drawerOpenAt = Date.now();
        if (reduce) return;
        [].slice.call(t.querySelectorAll(SEL)).forEach(function (img) { img.__dhd = 1; enqueue(img, true); });
      });
    }).observe(d.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });
  } catch (e) {}

  /* Symbols that arrive later (cart lines, filtered cards, quick view lists). */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; scan(); }, 40);
  }
  try {
    new MutationObserver(schedule).observe(d.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
